
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 import { SkyBadge as SkyBadgeElement, SkyBadgeClickEventDetail } from '@sky.ui/core/sky-badge';
 
 

 
 export const SkyBadge = createComponent({
   displayName: 'SkyBadge',
   react: React,
   tagName: 'sky-badge',
   elementClass: SkyBadgeElement,
   events: {
     
     onBadgeClick: 'badge-click' as EventName<CustomEvent<SkyBadgeClickEventDetail>>,
   }
  });
export type * from '@sky.ui/core/sky-badge';
